import React, { PureComponent } from 'react';

import Icon from '~/core/scripts/components/Icon';
import withSlide from '~/kits/general/scripts/components/withSlide';

import './Outro.styl';

class Outro extends PureComponent {
  render() {
    return (
      <footer className="footer">
        <div className="footer__top">
          <div className="footer__credits">Von <a target="_blank" href="https://www.twitter.com/datentaeterin">Marie-Louise Timcke</a>, <a target="_blank" href="https://www.twitter.com/alterpaetz">André Pätzold</a>, <a target="_blank" href="http://www.twitter.com/newreld">David Wendler</a>, <a target="_blank" href="https://webkid.io/">Christopher Möller</a> und <a target="_blank" href="https://webkid.io/">Moritz Klack</a></div>
          <div className="footer__source">
          Die Auswertung basiert auf <a target="_blank" href="https://europawahlergebnis.eu">Wahldaten des Europäischen Parlaments</a>. Die Bewertung einer Partei erfolgte zweistufig: Grundlage war zunächst die Zugehörigkeit zu einer Parteienfamilie laut <a target="_blank" href="http://www.parlgov.org/">Parlgov.org</a>. Diese wurde um die Bewertung von <a target="_blank" href="https://popu-list.org">Popu-list.org</a> ergänzt: Parteien, die dort als “far-right” klassifiziert sind, wurden dem rechten Lager zugeschlagen - wie die ungarische Fidesz oder polnische PiS. Hinzu kommen eigene Bewertungen für Parteien, die jüngst als rechtspopulistisch bekannt geworden sind, aber bei Popu-list.org noch nicht aufgeführt sind - wie Vox in Spanien.
          </div>
        </div>
        <div className="footer__bot">
          <div className="footer__interaktiv">
            <div className="footer__interaktiv-logo"><img src="images/logos/fi-signet-color.png" /></div>
            <div className="footer__interaktiv-title">Ein Projekt des Interaktiv-Teams der Funke Mediengruppe.</div>
            <div className="footer__interaktiv-body">Haben Sie Anmerkungen oder einen Fehler entdeckt? Wir freuen uns über Ihre <a target="_blank" href="mailto:interaktiv@funkemedien.de">Mail.</a></div>
          </div>
          <div className="footer__imprint">
            {ARTICLE_CONFIG.meta.ogSiteName}, {ARTICLE_CONFIG.datePublished}<br />
            <a href="<%=publication.imprintUrl%>" target="_blank">Impressum</a> / <a href="<%=publication.privacyUrl%>" target="_blank">Datenschutz</a>
          </div>
        </div>
      </footer>
    );
  }
}

export default withSlide(Outro);
